<template>
  <section>
    <notifications></notifications>
    <sidebar-help
      :title="$route.meta.title"
      :items="guides"
      :loader="loader"
      :toggleSidebar="visibleSideBar"
      @closeSidebar="closeSidebar"
    />

    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-4 col-md-6 col-sm-6 col-5 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-6 col-7 text-right">
          <div class="box-buttons">
            <base-button
              v-if="selectedRows.length > 0"
              type="outline-neutral"
              class="min-button btn-line-danger mr-2"
              @click="deleteMany(selectedRows)"
            >
              <i class="flaticon-delete icon-no-margin"></i>
              <strong class="d-lg-block d-none">Delete</strong>
            </base-button>

            <base-button
              type="primary"
              @click="$router.push('/users/new')"
              class="min-button"
            >
              <i class="flaticon-plus"></i>New
              <strong class="d-lg-block d-none ml-1"> User</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="main-buttons">
        <div class="row">
          <div
            class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 align-self-center mb-0"
          >
            <b-form-group class="mb-0">
              <b-input-group size="sm" class="input-search">
                <b-input-group-prepend class="pt-1 pl-1">
                  <i class="flaticon-bold-magnifier"></i>
                </b-input-group-prepend>
                <b-form-input
                  id="filter-input"
                  v-model.trim="simpleSearch"
                  v-on:input="applySimpleSearch"
                  type="search"
                  placeholder="Search Anything..."
                  class="border-none"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div
            class="col-xl-8 col-lg-8 col-md-6 col-sm-6 col-12 alinmov2 align-self-center"
          >
            <div>
              <div class="box-buttons">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="btn min-button btn-outline-neutral "
                  title="Actions"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-employees"></i>
                    <strong>User Role</strong>
                  </base-button>
                  <div
                    class="dropdown-item"
                    :class="userRole === 'all' ? 'active' : ''"
                    @click="typeSearch('all')"
                  >
                    All
                  </div>
                  <div
                    class="dropdown-item"
                    :class="userRole === 'supplier_access' ? 'active' : ''"
                    @click="typeSearch('supplier_access')"
                  >
                    Manager Access
                  </div>

                  <div
                    class="dropdown-item"
                    :class="userRole === 'dispatcher_access' ? 'active' : ''"
                    @click="typeSearch('dispatcher_access')"
                  >
                    Dispatcher
                  </div>
                </base-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-table">
        <div class="row">
          <div
            class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2"
          ></div>

          <div
            class="col-xl-7 col-lg-5 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 align-self-center mb-lg-0 mb-3 text-right"
          >
            <div class="col-xl-7 col-lg-12 col-md-6 ml-auto d-inline-block">
              <b-form-group
                label="Sort"
                label-for="sort-by-select"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                v-slot="{ ariaDescribedby }"
                class=""
                size="sm"
              >
                <b-input-group>
                  <b-form-select
                    id="sort-by-select"
                    v-model="sortBy"
                    :options="sortOptions"
                    :aria-describedby="ariaDescribedby"
                    @change="applySortBy"
                    class="w-70"
                    size="sm"
                  >
                    <template #first>
                      <option value="">-- None --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    @change="applySortType"
                    :aria-describedby="ariaDescribedby"
                    class="w-30"
                    size="sm"
                  >
                    <option :value="'asc'">Asc</option>
                    <option :value="'desc'">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2">
              <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="view"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  @change="changeViewCard"
                  class="mb-0"
                  button-variant="outline-neutral pc-3"
                >
                  <b-form-radio value="table"
                    ><i class="flaticon-two" title="View Table"></i
                  ></b-form-radio>
                  <b-form-radio value="card"
                    ><i class="flaticon-menu" title="View Card"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2">
              <el-tooltip content="Export" placement="bottom">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="div"
                  title-tag="a"
                  title-classes="btn btn-outline-neutral btn-icon-only m-0 dropnocaret"
                  title="Export"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-downloading-files mr-0 mt-1"></i>
                  </base-button>

                  <div
                    class="dropdown-item"
                    @click="download(selectedRows)"
                    v-if="selectedRows.length > 0"
                  >
                    Selected Records
                  </div>
                  <div class="dropdown-item" @click="download()">
                    All Records
                  </div>
                </base-dropdown>
              </el-tooltip>
            </div>

            <div class="d-inline-block">
              <el-tooltip content="Help" placement="bottom">
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="openSideBar"
                >
                  <i class="flaticon-question-1 f-16 mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>

        <pagination-block
          :pageCount="usersResponse.pages"
          :total="usersResponse.count"
          v-model="currentPage"
          :limit="limit"
          @changeLimit="changeLimit"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="previousPaginations"
          position="bottom"
        ></pagination-block>

        <b-table
          hover
          :items="users"
          :fields="fields"
          sort-by.sync="created_at"
          sort-asc.sync="true"
          selectable
          @row-selected="onRowSelected"
          select-mode="multi"
          ref="selectableTable"
          sort-icon-left
          responsive
          show-empty
          empty-filtered-text="There are no records matching your request"
          empty-text="There are no records to show"
          :stacked="cardview"
        >
          <template #head()="{ label, field: { key } }">
            <span v-if="key === 'selected'">
              <span
                @click="clearSelected"
                v-if="selectedRows.length == users.length"
                class="check-table selected"
              ></span>

              <span @click="selectAllRows" v-else class="check-table"></span>
            </span>
            <span v-else>{{ label }}</span>
          </template>
          <template #cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span aria-hidden="true" class="check-table selected"></span>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <span aria-hidden="true" class="check-table"></span>
              <span class="sr-only">Not selected</span>
            </template>
          </template>

          <template #cell(name)="data">
            <div class="d-flex align-items-center link-img-profile">
              <div
                v-if="data.item.profile.image"
                class="img-user-list mr-2"
                v-bind:style="{
                  backgroundImage: `url('${data.item.profile.image}')`
                }"
              ></div>

              <div
                v-else
                class="img-user-list mr-2"
                v-bind:style="{
                  backgroundImage: 'url(' + imageProfile + ')'
                }"
              ></div>

              <div class="d-inline-flex">
                <div>
                  <router-link
                    class="capitalize hide-data"
                    :to="`/users/${data.item._id}`"
                  >
                    {{ data.item.personal_info.first_name }}
                    {{ data.item.personal_info.last_name }}</router-link
                  >
                </div>
              </div>
            </div>
          </template>

          <template #cell(email)="data">
            <a
              class="hide-data"
              :href="`mailto:${data.item.account.email}`"
              target="_blank"
              >{{ data.item.account.email }}</a
            >
          </template>
          <template #cell(role)="data">
            <span class="text-capitalize">{{
              data.item.relationship.type | typeOperator
            }}</span>
          </template>

          <template #cell(status)="data">
            <div
              class="badge-status badge-success"
              v-if="data.item.profile.status == true"
            >
              <span>Active</span>
            </div>

            <div class="badge-status badge-danger" v-else>
              <span>Inactive</span>
            </div>
          </template>

          <template #cell(actions)="data">
            <el-tooltip content="Edit" placement="bottom">
              <router-link
                class="icon-action text-blue"
                :to="`/users/${data.item._id}`"
              >
                <i class="flaticon-pencil text-primary"></i>
              </router-link>
            </el-tooltip>

            <el-tooltip
              v-if="data.item.profile.status"
              content="Deactivate"
              placement="bottom"
            >
              <span
                class="icon-action text-info ml-2"
                @click.stop="changeStatus(data.item._id, false)"
              >
                <i class="flaticon-right-4"></i>
              </span>
            </el-tooltip>

            <el-tooltip v-else content="Active" placement="bottom">
              <span
                class="icon-action text-info ml-2"
                @click.stop="changeStatus(data.item._id, true)"
              >
                <i class="flaticon-right-4"></i>
              </span>
            </el-tooltip>

            <el-tooltip content="Delete" placement="bottom">
              <span
                class="icon-action text-danger ml-2"
                @click.stop="deleteUser(data.item._id)"
              >
                <i class="flaticon-delete"></i>
              </span>
            </el-tooltip>
          </template>
        </b-table>
        <pagination-block
          :pageCount="usersResponse.pages"
          :total="usersResponse.count"
          :limit="limit"
          @changeLimit="changeLimit"
          v-model="currentPage"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="previousPaginations"
          position="bottom"
        ></pagination-block>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapMutations, mapGetters, mapActions } from "vuex";
import endpoint from "../../Commons/Services/index";
import Swal from "sweetalert2";
import moment from "moment";
import localHelper from "../Commons/Helper";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
import { goBack, unauthorizedAction } from "../../../helpers/commons.helpers";
export default {
  name: "Users",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
      currentPage: 1,
      selectedRows: [],
      limit: 0,
      searchQuery: "",
      query: "",
      searchStatus: "",
      fields: [
        {
          key: "selected",
          label: "",
          sortable: false,
          class: "text-center",
          thStyle: { minWidth: "40px" }
        },
        {
          key: "name",
          label: "User",
          sortable: true,
          thStyle: { minWidth: "150px" },
          class: "text-left"
        },

        {
          key: "email",
          label: "Email",
          sortable: true,
          thStyle: { minWidth: "150px" },
          class: "text-left"
        },
        {
          key: "role",
          label: "Role",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },

        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "alinmov6",
          thStyle: { minWidth: "80px" }
        }
      ],
      cardview: false,
      view: "table",
      simpleSearch: "",
      userRole: "",
      sortBy: "",
      sortDesc: "asc",
      sortDirection: "asc",
      sortOptions: [
        {
          value: "name",
          text: "User Name"
        },
        {
          value: "email",
          text: "Email"
        },
        { value: "created_at", text: "Created At" }
      ],
      imageProfile: require("rhomtrip_assets/src/img/users/user-placeholder.png"),
      visibleSideBar: false,
      guides: [],
      loader: false
    };
  },

  async created() {
    var bread = [
      {
        text: "Users",
        active: true
      }
    ];
    this.setItemsBread(bread);
    await this.getLimit();
    this.limit = this.paginationLimit;
    this.query = this.usersSearchCriteria.query;
    this.currentPage = this.usersSearchCriteria.currentPage;
    this.initializeFilterData(this.query);
    this.get(true, this.limit, this.currentPage, this.query);
  },
  methods: {
    get(loader, limit, page, query) {
      this.setUsersSearchCriteria({
        currentPage: page,
        query: query,
        limit: limit,
        status: true
      });
      this.getUsers({
        loader: loader,
        limit: limit,
        page: page,
        query: query
      });
    },
    changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        this.get(true, this.limit, this.currentPage, this.query);
      }
    },
    previousPaginations(page) {
      this.get(true, this.limit, page, this.query);
    },
    nextPaginations(page) {
      this.get(true, this.limit, page, this.query);
    },
    changePage(page) {
      this.get(true, this.limit, page, this.query);
    },
    addElementInQuery(query, key, value) {
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, value.trim());
      } else {
        searchParams.append(key, value.trim());
      }
      return searchParams.toString();
    },
    deleteItemInQuery(query, keys = []) {
      let searchParams = new URLSearchParams(query);
      keys.forEach(key => {
        if (searchParams.has(key)) {
          searchParams.delete(key);
        }
      });
      return searchParams.toString();
    },
    applySimpleSearch(value) {
      this.query = this.addElementInQuery(this.query, "search", value);
      this.get(true, this.limit, 1, this.query);
    },
    typeSearch(type) {
      this.userRole = type;
      if (type === "all") {
        this.query = this.deleteItemInQuery(this.query, ["type"]);
        this.get(true, this.limit, 1, this.query);
      } else {
        this.query = this.addElementInQuery(this.query, "type", type);
        this.get(true, this.limit, 1, this.query);
      }
    },
    async applySortBy(value) {
      this.query = this.addElementInQuery(this.query, "sortBy", value);
      this.query = this.addElementInQuery(
        this.query,
        "sortType",
        this.sortDesc
      );
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    async applySortType(value) {
      this.query = this.addElementInQuery(this.query, "sortType", value);
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    async deleteUser(userId) {
      let { value } = await Swal.fire({
        title: "Delete user",
        text: "Are you sure do you want to delete this User?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteUserById(userId);
      }
    },
    async deleteUserById(userId) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.users.services.deleteUser(
          userId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The User has been Deleted",
            icon: "flaticon-check-3"
          });
          await this.get(false, this.limit, this.currentPage, this.query);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async deleteMany() {
      let { value } = await Swal.fire({
        title: "Delete users",
        text: "Are you sure do you want to delete the selected Users?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteManyUsersById(
          this.selectedRows.map(element => element._id)
        );
      }
    },
    async deleteManyUsersById(users = []) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.users.services.deleteUsersMany(
          { users: users },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Users has been Deleted",
            icon: "flaticon-check-3"
          });
          await this.get(false, this.limit, this.currentPage, this.query);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async changeStatus(userId, status) {
      let { value } = await Swal.fire({
        title: "Change Status",
        text: `Are you sure do you want change status the selected User?`,
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.changeStatusByUserId(userId, status);
      }
    },
    async changeStatusByUserId(userId, status) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.users.services.updateSameAttribute(
          userId,
          { "profile.status": status },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.updated) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Users has been Updated",
            icon: "flaticon-check-3"
          });
          await this.get(false, this.limit, this.currentPage, this.query);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async download(users = []) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.exports.services.exportCSVUsers(
          { operators: users },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.code === 200) {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `users-${moment().format("DD-MM-YYYY")}.csv.csv`
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = unauthorizedAction(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    getOwner(sesion) {
      return sesion.role === sesion.account_type.type
        ? sesion.id
        : sesion.account_type.owner;
    },
    viewCard() {
      this.cardview = !this.cardview;
    },
    initializeFilterData(query) {
      let searchCriteria = new URLSearchParams(query);
      this.simpleSearch = searchCriteria.has("search")
        ? searchCriteria.get("search")
        : "";
      this.userRole = searchCriteria.has("type")
        ? searchCriteria.get("type")
        : "all";
    },
    changeViewCard() {
      if (this.view === "table") {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    async openSideBar() {
      this.visibleSideBar = true;
      this.loader = true;
      this.guides = await this.getSupportDocuments("SUPPLIERS", "USERS");
      this.loader = false;
    },
    closeSidebar(status) {
      this.visibleSideBar = status;
    },
    async getSupportDocuments(app, module) {
      try {
        let { data } = await endpoint.documents.services.getSupportDocuments(
          app,
          module,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    ...mapActions(["getUsers", "getLimit"]),
    ...mapMutations(["setLoad", "setItemsBread", "setUsersSearchCriteria"])
  },
  computed: {
    users: function() {
      try {
        if (this.usersResponse.docs) {
          return this.usersResponse.docs;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    ...mapGetters([
      "usersResponse",
      "sesion",
      "paginationLimit",
      "usersSearchCriteria"
    ])
  },
  filters: {
    typeOperator: function(type) {
      if (type === "admin_access") {
        return "Admin Access";
      } else if (type === "company_access") {
        return "Company Access";
      } else if (type === "supplier_access") {
        return "Manager Access";
      } else if (type === "dispatcher_access") {
        return "Dispatcher";
      }
    },
    statusOperator: function(status) {
      if (status) {
        return "Active";
      } else {
        return "Inactive";
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    localHelper.isInUsersModule(
      to.meta.modules,
      this.setUsersSearchCriteria,
      "users"
    );
    next();
  }
};
</script>
<style lang="scss"></style>
